export const CANVAS_COLORS = {
    'DRAW-CONTOUR':'#695c00',//'#b5a21b',
    'ZONE-ROOF' : [
    '#0000ff',
    '#a52a2a',
    '#008b8b',
    '#a9a9a9',
    '#bdb76b',
    '#8b008b',
    '#00ffff',
    '#006400',
    '#ff8c00',
    '#9932cc',
    '#8b0000',
    '#e9967a',
    '#00008b',
    '#556b2f',
    '#ffd700',
    '#4b0082',
    '#008000',
    '#f0e68c',
    '#add8e6',
    '#00ff00',
    '#ff00ff',
    '#800000',
    '#000080',
    '#ffa500',
    '#ffc0cb',
    '#800080',
    '#ff0000',
    '#90ee90',
    '#ff00ff',
    '#c0c0c0',
    '#ffff00',
    '#00ffff',
    '#458532',
    '#bd495f',
    '#5aaac6',
    '#117694',
    '#808000',
    '#ffb6c1',
    '#9400d3'
    ],
}